import { useForm } from '@graphcommerce/ecommerce-ui'
import { useMutation } from '@graphcommerce/graphql'
import { CustomerQuery } from '@graphcommerce/magento-customer'
import { MessageSnackbar, Button } from '@graphcommerce/next-ui'
import { Trans } from '@lingui/react'
import { Box, Typography, InputBase } from '@mui/material'
import { atob } from 'atob/node-atob'
import { StockSubscribeDocument } from '../AmxnotifStockSubscribe.gql'

export type FormCustomerProps = React.ComponentProps<typeof FormCustomer>

export function FormCustomer(props: {
  productUid: string
  customer: CustomerQuery
  wishlistButton?: React.ReactNode
}) {
  const { productUid, customer, wishlistButton } = props

  const {
    register,
    handleSubmit,
    formState: { isSubmitting, isSubmitSuccessful },
  } = useForm()

  const [StockSubscribeMutation] = useMutation(StockSubscribeDocument)

  const onSubmit = async (data) => {
    await StockSubscribeMutation({
      variables: {
        product_id: parseInt(atob(productUid) as string, 10),
        email: data.emailAddress,
        gdpr_agreement: false,
      },
    })
  }

  const submitSuccess = !isSubmitting && isSubmitSuccessful

  return (
    <>
      <Typography component='p' variant='subtitle2' sx={[{ marginBottom: '5px' }]}>
        <Trans id='Subscribe to back in stock notification' />
      </Typography>
      <Box sx={{ display: 'grid' }}>
        <InputBase type='hidden' value={customer?.customer?.email} {...register('emailAddress')} />
        <Box
          sx={[
            (theme) => ({
              display: 'grid',
              alignItems: 'center',
              gridTemplateColumns: '1fr auto',

              [theme.breakpoints.up('sm')]: {
                gridColumnGap: theme.spacings.xxs,
              },
            }),
          ]}
        >
          <Button
            type='submit'
            variant='contained'
            color='primary'
            fullWidth
            disabled={submitSuccess}
            loading={isSubmitting}
            onClick={handleSubmit(onSubmit)}
            sx={(theme) => ({
              paddingTop: theme.spacings.xxs,
              paddingBottom: theme.spacings.xxs,
              height: 'auto',
              lineHeight: 1,
            })}
          >
            <Trans id='Notify me' />
          </Button>
          {wishlistButton}
        </Box>
      </Box>
      <MessageSnackbar open={submitSuccess} variant='pill'>
        <Trans id='You are subscribed to the out of stock list' />
      </MessageSnackbar>
    </>
  )
}
